const HideLoader = () => {

	/**
	 * スマホ用のカタログを生成
	 */
	const container = document.getElementById('js-loading-effect');

	if (container) {
		container.classList.add('hide-loader');
	}
	
}

export default HideLoader;